import React from 'react';
import CommonBanner from '../component/Common/CommonBanner'
import WhyWeExist from '../component/Home/WhyWeExist';
import Forms from '../component/Home/Forms';

const WhyWeExistPage = () => {

    return (
        <>
            <CommonBanner heading="Partnership" pagination="Partnership" />
            
            <Forms />
        </>
    );
};

export default WhyWeExistPage;
